// event names
export const CHANGE_COLOR_EVENT = "Botsonic:changeColor";
export const CHANGE_COMPANY_NAME_EVENT = "Botsonic:changeCompanyName";
export const CHANGE_COMPANY_LOGO_EVENT = "Botsonic:changeCompanyLogo";
export const CHANGE_BOT_AVATAR_EVENT = "Botsonic:changeBotAvatar";
export const CHANGE_WELCOME_MESSAGE = "Botsonic: changeWelcomeMessage";
export const CHANGE_STARTER_QUESTIONS_EVENT = "ws:changeStarterQuestionsEvent";
export const CHANGE_SHOW_BRAND_EVENT = "Botsonic:changeShowBrand";
export const CHANGE_BUTTON_ICON_EVENT = "Botsonic:changeButtonIcon";
export const CHANGE_CHATBOT_SUBHEADING_EVENT =
  "Botsonic:changeChatBotSubheading";
export const UPDATE_USER_FORM = "Botsonic:updateUserForm";
export const CHANGE_CUSTOM_PLACEHOLDER_EVENT =
  "Botsonic:changeCustomPlaceholderEvent";
export const CHANGE_USER_FORM_VISIBILITY = "Botsonic:changeUserFormVisibility";
export const CREATE_CONVERSATION_ID = "Botsonic:createConversationID";
export const CHANGE_SHOW_SOURCES = "Botsonic:changeShowSources";
export const CHANGE_SERVER_ERROR_MESSAGE_EVENT =
  "Botsonic:changeServerErrorMessageEvent";
export const CHANGE_NO_SOURCES_ADDED_MESSAGE_EVENT =
  "Botsonic:changeNoSourcesAddedMessageEvent";
export const CHANGE_SHOW_FLOATING_WELCOME_MESSAGE_EVENT =
  "Botsonic:changeShowFloatingWelcomeMessageEvent";
export const CHANGE_SHOW_FLOATING_STARTER_QUESTIONS =
  "Botsonic:changeShowFloatingStarterQuestions";

// These events are not intended to be used by end users on their own hosts
export const INTERNAL_PORTAL_EVENT = "Botsonic:internalPortalEvent";
